import { IApplicationState } from '../../types/redux';

export const selectUserPhone = (state: IApplicationState): string => {
  return state.user.phones?.[0]?.phone || '';
};
